import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SegmentedControlField } from '../SegmentedControlField';

type RevenuePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const Revenue = <T extends FieldValues>({
  fieldName,
}: RevenuePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <SegmentedControlField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.REVENUE')}
      options={[
        { value: false, label: t('REPORTS.ENUMS.REVENUE.WITHOUT') },
        { value: true, label: t('REPORTS.ENUMS.REVENUE.WITH') },
      ]}
    />
  );
};
